export const COUNTRY_LIST = [
    {
        name: '中国',
        areaName: 'ZH',
        translateUpperName: 'ZH',
        translateLowerName: 'zh',
        formData: {
            title: '',
            titleDifferentiation: '',
            areaName: 'ZH',
            bluePoints: ['', '', '', '', ''],
            keyword: '',
            briefIntroduction: '',
        },
        editorLength: 0,
    },
    {
        name: '英国',
        areaName: 'GB',
        translateUpperName: 'EN',
        translateLowerName: 'en',
        formData: {
            title: '',
            titleDifferentiation: '',
            areaName: 'GB',
            bluePoints: ['', '', '', '', ''],
            keyword: '',
            briefIntroduction: '',
        },
        editorLength: 0,
    },
    {
        name: '德国',
        areaName: 'DE',
        translateUpperName: 'DE',
        translateLowerName: 'de',
        formData: {
            title: '',
            titleDifferentiation: '',
            areaName: 'DE',
            bluePoints: ['', '', '', '', ''],
            keyword: '',
            briefIntroduction: '',
        },
        editorLength: 0,
    },
    {
        name: '法国',
        areaName: 'FR',
        translateUpperName: 'FRA',
        translateLowerName: 'fr',
        formData: {
            title: '',
            titleDifferentiation: '',
            areaName: 'FR',
            bluePoints: ['', '', '', '', ''],
            keyword: '',
            briefIntroduction: '',
        },
        editorLength: 0,
    },
    {
        name: '意大利',
        areaName: 'IT',
        translateUpperName: 'IT',
        translateLowerName: 'it',
        formData: {
            title: '',
            titleDifferentiation: '',
            areaName: 'IT',
            bluePoints: ['', '', '', '', ''],
            keyword: '',
            briefIntroduction: '',
        },
        editorLength: 0,
    },
    {
        name: '西班牙',
        areaName: 'ES',
        translateUpperName: 'ES',
        translateLowerName: 'es',
        formData: {
            title: '',
            titleDifferentiation: '',
            areaName: 'ES',
            bluePoints: ['', '', '', '', ''],
            keyword: '',
            briefIntroduction: '',
        },
        editorLength: 0,
    },
    {
        name: '荷兰',
        areaName: 'NL',
        translateUpperName: 'NL',
        translateLowerName: 'nl',
        formData: {
            title: '',
            titleDifferentiation: '',
            areaName: 'NL',
            bluePoints: ['', '', '', '', ''],
            keyword: '',
            briefIntroduction: '',
        },
        editorLength: 0,
    },
    {
        name: '瑞典',
        areaName: 'SE',
        translateUpperName: 'SE',
        translateLowerName: 'se',
        formData: {
            title: '',
            titleDifferentiation: '',
            areaName: 'SE',
            bluePoints: ['', '', '', '', ''],
            keyword: '',
            briefIntroduction: '',
        },
        editorLength: 0,
    },
    {
        name: '波兰',
        areaName: 'PL',
        translateUpperName: 'PL',
        translateLowerName: 'pl',
        formData: {
            title: '',
            titleDifferentiation: '',
            areaName: 'PL',
            bluePoints: ['', '', '', '', ''],
            keyword: '',
            briefIntroduction: '',
        },
        editorLength: 0,
    },
    {
        name: '沙特阿拉伯',
        areaName: 'SA',
        translateUpperName: 'SA',
        translateLowerName: 'sa',
        formData: {
            title: '',
            titleDifferentiation: '',
            areaName: 'SA',
            bluePoints: ['', '', '', '', ''],
            keyword: '',
            briefIntroduction: '',
        },
        editorLength: 0,
    },
    {
        name: '美国',
        areaName: 'US',
        translateUpperName: 'US',
        translateLowerName: 'us',
        formData: {
            title: '',
            titleDifferentiation: '',
            areaName: 'US',
            bluePoints: ['', '', '', '', ''],
            keyword: '',
            briefIntroduction: '',
        },
        editorLength: 0,
    },
    {
        name: '加拿大',
        areaName: 'CA',
        translateUpperName: 'CA',
        translateLowerName: 'ca',
        formData: {
            title: '',
            titleDifferentiation: '',
            areaName: 'CA',
            bluePoints: ['', '', '', '', ''],
            keyword: '',
            briefIntroduction: '',
        },
        editorLength: 0,
    },
    {
        name: '墨西哥',
        areaName: 'MX',
        translateUpperName: 'MX',
        translateLowerName: 'mx',
        formData: {
            title: '',
            titleDifferentiation: '',
            areaName: 'MX',
            bluePoints: ['', '', '', '', ''],
            keyword: '',
            briefIntroduction: '',
        },
        editorLength: 0,
    },
    {
        name: '日本',
        areaName: 'JP',
        translateUpperName: 'JP',
        translateLowerName: 'jp',
        formData: {
            title: '',
            titleDifferentiation: '',
            areaName: 'JP',
            bluePoints: ['', '', '', '', ''],
            keyword: '',
            briefIntroduction: '',
        },
        editorLength: 0,
    },
    {
        name: '澳洲',
        areaName: 'AU',
        translateUpperName: 'AU',
        translateLowerName: 'au',
        formData: {
            title: '',
            titleDifferentiation: '',
            areaName: 'AU',
            bluePoints: ['', '', '', '', ''],
            keyword: '',
            briefIntroduction: '',
        },
        editorLength: 0,
    },
    {
        name: '阿联酋',
        areaName: 'AE',
        translateUpperName: 'AE',
        translateLowerName: 'ae',
        formData: {
            title: '',
            titleDifferentiation: '',
            areaName: 'AE',
            bluePoints: ['', '', '', '', ''],
            keyword: '',
            briefIntroduction: '',
        },
        editorLength: 0,
    },
    {
        name: '新加坡',
        areaName: 'SG',
        translateUpperName: 'SG',
        translateLowerName: 'sg',
        formData: {
            title: '',
            titleDifferentiation: '',
            areaName: 'SG',
            bluePoints: ['', '', '', '', ''],
            keyword: '',
            briefIntroduction: '',
        },
        editorLength: 0,
    },
    {
        name: '印度',
        areaName: 'IN',
        translateUpperName: 'IN',
        translateLowerName: 'in',
        formData: {
            title: '',
            titleDifferentiation: '',
            areaName: 'IN',
            bluePoints: ['', '', '', '', ''],
            keyword: '',
            briefIntroduction: '',
        },
        editorLength: 0,
    },
    {
        name: '巴西',
        areaName: 'BR',
        translateUpperName: 'BR',
        translateLowerName: 'br',
        formData: {
            title: '',
            titleDifferentiation: '',
            areaName: 'BR',
            bluePoints: ['', '', '', '', ''],
            keyword: '',
            briefIntroduction: '',
        },
        editorLength: 0,
    },
];